/* Shared lazy lifecycle for the knock-down assembly video on both PDP variants. */
(function (root, factory) {
  'use strict';

  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (!root || !root.document) return;

  root.FlorafyVideoModal = api;

  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', function () {
      api.initVideoModals(root.document);
    });
  } else {
    api.initVideoModals(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var boundModals = new WeakSet();
  var loadedVideos = new WeakSet();

  function loadVideo(video) {
    if (!video || loadedVideos.has(video)) return;

    if (video.dataset.videoPoster) {
      video.poster = video.dataset.videoPoster;
    }

    video.querySelectorAll('source[data-video-src]').forEach(function (source) {
      source.src = source.dataset.videoSrc;
    });

    video.load();
    loadedVideos.add(video);
  }

  function resetVideo(video) {
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  }

  function initVideoModals(root) {
    root.querySelectorAll('.product-knockdown-modal').forEach(function (modal) {
      if (boundModals.has(modal)) return;
      boundModals.add(modal);

      modal.addEventListener('shown.bs.modal', function () {
        loadVideo(modal.querySelector('video[data-video-poster]'));
      });

      modal.addEventListener('hidden.bs.modal', function () {
        resetVideo(modal.querySelector('video[data-video-poster]'));
      });
    });
  }

  return {
    initVideoModals: initVideoModals,
  };
});
